module.exports = "<template>\n    <b-taglist>\n        <b-tag type=\"is-info\">First</b-tag>\n        <b-tag type=\"is-info\">Second</b-tag>\n        <b-tag type=\"is-info\">Third</b-tag>\n        <b-tag type=\"is-info\">Fourth</b-tag>\n        <b-tag type=\"is-info\">Fifth</b-tag>\n    </b-taglist>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/tag/examples/ExTaglist.vue
// module id = 1542
// module chunks = 16